var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFC144"
    },
    points: "136.001,200 204.979,200 216.001,200 256.001,240  296.001,200 307.023,200 376.001,200 376.001,134.678 376.001,10 136.001,10 136.001,134.678 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DDB9A3"
    },
    points: "204.979,200 136.001,200 136.001,134.678  10.001,189.001 89.001,250.002 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C68A65"
    },
    points: "204.979,200 89.001,250.002 256.001,322.002  423.001,250.002 307.023,200 296.001,200 256.001,240 216.001,200 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DDB9A3"
    },
    points: "256.001,322.002 89.001,250.002 10.001,311.003  89.001,345.062 177.001,383.003 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DDB9A3"
    },
    points: "256.001,322.002 177.001,383.003 89.001,345.063  89.001,430.002 256.001,502.002 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DDB9A3"
    },
    points: "256.001,322.002 335.001,383.003 423.001,345.062  502.001,311.003 423.001,250.002 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DDB9A3"
    },
    points: "335.001,383.003 256.001,322.002 256.001,502.002  423.001,430.002 423.001,345.062 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DDB9A3"
    },
    points: "307.023,200 423.001,250.002 502.001,189.001  376.001,134.678 376.001,200 \t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    d: " M213.829,303.82l42.172,18.182l167-72l79,61.001l-167,72l-79-61.001l-79,61.001l-167-72l79-61.001l42.166,18.179 M423.001,347.313 v82.689l-167,72l-167-72v-82.689"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: " 376.348,134.828 502.001,189.001 423.001,250.002 307.37,200.15 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: " 135.579,134.86 10.001,189.001 89.001,250.002 204.557,200.182 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    points: " 136.001,10 376.001,10 376.001,200 296.001,200 256.001,240 216.001,200 136.001,200 \t\t"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    d: " M256.001,121.788c0-11.912,1.083-13.415,16.107-29.156c3.814-3.996,6.156-9.409,6.156-15.369c0-12.295-9.967-22.262-22.263-22.262 c-12.296,0-22.263,9.967-22.263,22.262"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 255.995,
    y1: 154.999,
    x2: 256.001,
    y2: 154.999
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9256
    },
    x1: 256.001,
    y1: 332.002,
    x2: 256.001,
    y2: 497.002
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 172.494,
    y1: 286.002,
    x2: 172.501,
    y2: 286.002
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.17f2408dbf0cf21846d1b247b75860ab.svg";
export { ForwardRef as ReactComponent };